import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Menu, CheckCircle } from 'lucide-react'
import { useAuth, UserButton } from '@clerk/clerk-react'

export const AppHeader: React.FC<{
  onOpenSidebar: () => void
  hideHeader?: boolean
}> & {} = ({ onOpenSidebar, hideHeader }) => {
  const range = {
    start_date: '2025-09-01',
    end_date: '2025-09-30',
    verbose: false,
    echo_result_columns: true
  }
  const navigate = useNavigate()
  const { userId, isLoaded } = useAuth()

  if (hideHeader) return null

  return (
    <div className='sticky top-0 z-40 border-b border-gray-200 bg-white'>
      <div className='mx-auto max-w-7xl px-4 py-4 sm:px-6 lg:px-8'>
        <div className='flex items-center justify-between'>
          {/* left */}
          <div className='flex items-center gap-4'>
            <div className='flex items-center gap-2'>
              <button
                onClick={onOpenSidebar}
                className='rounded-lg p-2 transition-colors duration-200 hover:bg-gray-100'
                title='Open navigation menu'
              >
                <Menu className='h-8 w-8 text-slate-700' />
              </button>

              <div
                className='group cursor-pointer select-none'
                onClick={() => navigate('/')}
                onMouseEnter={() => {
                  // prefetchVolumeTrends(queryClient, range)
                  // ensureAgentTrends(queryClient, { ...range, contact_name: '' })
                }}
                title='Return to Dashboard'
              >
                <div className='flex items-center gap-1'>
                  <img
                    src='/images/proserve-logo.png'
                    alt='ProServe'
                    className='h-6 w-auto object-contain'
                    draggable={false}
                  />
                  <br />
                  <h1 className='text-sm font-bold text-gray-900 transition-colors duration-200 group-hover:text-blue-600'>
                    CS Portal
                  </h1>
                </div>
              </div>
            </div>
          </div>

          <div className='flex items-center gap-4'>
            {/* TODO:// kak - not sure this is needed? */}
            {/* <ConnectionStatus /> */}
            {isLoaded && userId ? (
              <UserButton
                afterSignOutUrl='/login'
                appearance={{
                  elements: { userButtonPopoverCard: 'shadow-xl' }
                }}
              />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  )
}
